import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32b5d1b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "CookiesRow W-75",
  style: {"margin-top":"4em","font-size":"1.1em"}
}
const _hoisted_2 = { class: "SettingsName" }
const _hoisted_3 = { class: "CookiesRow" }
const _hoisted_4 = ["ToolTip"]
const _hoisted_5 = ["ToolTip"]
const _hoisted_6 = ["ToolTip"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"20%"} }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_9 = { class: "SettingsName" }
const _hoisted_10 = { class: "CookiesRow" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"20%"} }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_13 = { class: "SettingsName" }
const _hoisted_14 = { class: "CookiesRow BackgroundContainer" }
const _hoisted_15 = { class: "D-Flex" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "M-Auto ColorBox BG2 Shadow1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "BGGradient" })
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesColSplitter" }, null, -1))
const _hoisted_18 = { class: "D-Flex" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "M-Auto ColorBox BG2 Shadow1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "BGThird" })
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesColSplitter" }, null, -1))
const _hoisted_21 = { class: "D-Flex" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "M-Auto ColorBox BG2 Shadow1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "BGDimmed" })
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesColSplitter" }, null, -1))
const _hoisted_24 = { class: "D-Flex" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "M-Auto ColorBox BG2 Shadow1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "BG1Fixed" })
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"20%"} }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_28 = { class: "SettingsName" }
const _hoisted_29 = { class: "CookiesRow" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"20%"} }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_32 = { class: "SettingsName" }
const _hoisted_33 = { class: "CookiesRow" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesColSplitter" }, null, -1))
const _hoisted_35 = { class: "V-Auto P1em" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"20%"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesColorPicker = _resolveComponent("CookiesColorPicker")!
  const _component_CookiesRadioButton = _resolveComponent("CookiesRadioButton")!
  const _component_CookiesCheckBox = _resolveComponent("CookiesCheckBox")!
  const _component_CookiesDropDown = _resolveComponent("CookiesDropDown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.Translate('Theme')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ChooseTheme('auto'))),
        ToolTip: _ctx.Translate('Auto'),
        class: "Shadow1 InnerShadow Pointer",
        style: _normalizeStyle(['outline: solid 0.25em ' + _ctx.Theme.BG2 + ';', {"width":"2em","height":"2em","border-radius":"50%","margin":"0em 0.5em","background":"linear-gradient(45deg, rgb(240,240,240), rgb(240,240,240) 49.5%, rgb(35,35,35) 50.5%, rgb(35,35,35) 100%)"}])
      }, null, 12, _hoisted_4),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ChooseTheme('light'))),
        ToolTip: _ctx.Translate('Light'),
        class: "Shadow1 Pointer",
        style: _normalizeStyle(['outline: solid 0.25em ' + _ctx.Theme.BG2 + ';', {"width":"2em","height":"2em","border-radius":"50%","margin":"0em 0.5em","background":"rgb(240,240,240)"}])
      }, null, 12, _hoisted_5),
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ChooseTheme('dark'))),
        ToolTip: _ctx.Translate('Dark'),
        class: "Shadow1 Pointer",
        style: _normalizeStyle(['outline: solid 0.25em ' + _ctx.Theme.BG2 + ';', {"width":"2em","height":"2em","border-radius":"50%","margin":"0em 0.5em","background":"rgb(35,35,35)"}])
      }, null, 12, _hoisted_6)
    ]),
    _hoisted_7,
    _hoisted_8,
    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.Translate('Main Color')), 1),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_CookiesColorPicker, {
        onColorChanged: _cache[3] || (_cache[3] = ($event: any) => (_ctx.SaveConfig('color', _ctx.$store.state.CookiesConfig.color))),
        Res: 'color'
      })
    ]),
    _hoisted_11,
    _hoisted_12,
    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.Translate('Background')), 1),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_CookiesRadioButton, {
          onChanged: _cache[4] || (_cache[4] = ($event: any) => (_ctx.SaveConfig('background', _ctx.MEMRead('SystemBackground')))),
          Default: _ctx.$store.state.CookiesConfig.background === 'BGGradient',
          Value: 'BGGradient',
          Name: _ctx.Translate('Gradient'),
          Res: 'SystemBackground'
        }, null, 8, ["Default", "Name"]),
        _hoisted_16
      ]),
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_CookiesRadioButton, {
          onChanged: _cache[5] || (_cache[5] = ($event: any) => (_ctx.SaveConfig('background', _ctx.MEMRead('SystemBackground')))),
          Default: _ctx.$store.state.CookiesConfig.background === 'BGThird',
          Value: 'BGThird',
          Name: _ctx.Translate('Solid'),
          Res: 'SystemBackground'
        }, null, 8, ["Default", "Name"]),
        _hoisted_19
      ]),
      _hoisted_20,
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_CookiesRadioButton, {
          onChanged: _cache[6] || (_cache[6] = ($event: any) => (_ctx.SaveConfig('background', _ctx.MEMRead('SystemBackground')))),
          Default: _ctx.$store.state.CookiesConfig.background === 'BGDimmed',
          Value: 'BGDimmed',
          Name: _ctx.Translate('Darker'),
          Res: 'SystemBackground'
        }, null, 8, ["Default", "Name"]),
        _hoisted_22
      ]),
      _hoisted_23,
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_CookiesRadioButton, {
          onChanged: _cache[7] || (_cache[7] = ($event: any) => (_ctx.SaveConfig('background', _ctx.MEMRead('SystemBackground')))),
          Default: _ctx.$store.state.CookiesConfig.background === 'BG1Fixed',
          Value: 'BG1Fixed',
          Name: _ctx.Translate('Blank'),
          Res: 'SystemBackground'
        }, null, 8, ["Default", "Name"]),
        _hoisted_25
      ])
    ]),
    _hoisted_26,
    _hoisted_27,
    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.Translate('Transparency')), 1),
    _createElementVNode("div", _hoisted_29, [
      _createVNode(_component_CookiesCheckBox, {
        onChanged: _cache[8] || (_cache[8] = ($event: any) => (_ctx.SaveConfig('Transparent', _ctx.MEMRead('Config_Transparency')))),
        Default: _ctx.$store.state.CookiesConfig.Transparent,
        Type: 'Switch',
        Res: 'Config_Transparency'
      }, null, 8, ["Default"])
    ]),
    _hoisted_30,
    _hoisted_31,
    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.Translate('Default Language')), 1),
    _createElementVNode("div", _hoisted_33, [
      _createVNode(_component_CookiesDropDown, {
        onSlection_changed: _ctx.LanguageChanged,
        IndexSelect: _ctx.LanguageIndex,
        Res: 'Config_Language',
        Width: '10em',
        Type: 'Object',
        Selector: ['Name'],
        Radio: true,
        Options: _ctx.LanguagesArray
      }, null, 8, ["onSlection_changed", "IndexSelect", "Options"]),
      _hoisted_34,
      _createElementVNode("div", _hoisted_35, [
        _createVNode(_component_CookiesCheckBox, {
          onChanged: _ctx.LanguageUserSelectChanged,
          Res: 'Config_LanguageUserSelect',
          Type: 'Switch',
          Name: _ctx.Translate('Let the user Choose first time')
        }, null, 8, ["onChanged", "Name"])
      ])
    ]),
    _hoisted_36
  ]))
}